export default [
  {
    path: '/bulk_verify_email',
    name: 'BulkVerify',
    component: () =>
      import(
        '@/modules/uploadCSV/pages/verifyEmail/EmailVerifierUploadCSV.vue'
      ),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk Email Verifier',
      breadcrumb: [
        {
          text: 'Bulk Email Verifier',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulk_verify_map/:id',
    name: 'BulkVerifyMap',
    component: () =>
      import(
        '@/modules/uploadCSV/pages/verifyEmail/EmailVerifierUploadCSV.vue'
      ),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk Verify Map',
      breadcrumb: [
        {
          text: 'Map Columns',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulk_verify_list',
    name: 'BulkVerifyList',
    component: () =>
      import(
        '@/modules/uploadCSV/pages/verifyEmail/EmailVerifierUploadCSVBulkList.vue'
      ),
    meta: {
      authRequired: true,
      pageTitle: 'Bulk List',
      breadcrumb: [
        {
          text: 'Bulk Emails List',
          active: true,
        },
      ],
    },
  },
];
